module.exports = __webpack_public_path__ + "img/Article-image21.63022b40.jpg";